import { createFileRoute } from '@tanstack/react-router';

import { PortalTributario } from '@/features/portal/portal-tributario';

export const Route = createFileRoute('/portal/tributario')({
  component: PortalTributario,
});
